<div class="flex-col full-height">
  @if (!isProjectComponentlist) {
  <app-info-page
    title="{{ 'component.componentsOverviewTitle' | translate }}"
    [isComponentOrProject]="isProjectComponentlist ? 'PROJECT' : 'COMPONENT'"
  >
    <div ngProjectAs="buttons">
      <app-button
        theme="primary"
        [id]="'btn-create-component'"
        class="btn-create-component"
        [routerLink]="['/components/create']"
        [queryParams]="{ solution: activeLink, origin: getOrigin() }"
        buttonText="{{ 'component.createComponent' | translate }}"
        iconUrl="/assets/icons/icon-16-add.svg"
      ></app-button>
    </div>
  </app-info-page>
  @if (dualSolutions()) {
  <nav mat-tab-nav-bar [tabPanel]="tabPanel" class="solution-tabs">
    @for (link of links; track link.id) {
    <a
      mat-tab-link
      [id]="'link-tab-' + link.id"
      [routerLink]="link.path"
      (click)="activeLink = link.id"
      [active]="activeLink === link.id"
    >
      {{ link.label | translate }}
    </a>
    }
  </nav>
  } }
  <mat-tab-nav-panel
    #tabPanel
    class="solution-panel"
    [attr.role]="!isProjectComponentlist && dualSolutions() ? 'tabpanel' : null"
  >
    <div class="filter-wrapper" [appHideOnScroll]="40"
      [hideOnScrollDisabled]="selectedIds.length > 0">
      <app-components-menu
        #componentsFilters
        (updateData)="updateFilter($event)"
        [canSwapToMap]="true"
        [isProjectComponentlist]="isProjectComponentlist"
        [types]="types"
        [projects]="projects"
        [geofences]="geofences"
        [selectedRows]="selectedIds.length"
        [filterOptions]="solutionSpace === ENUM_UtilOrHumid.Utilization ? utilizationFiltersOption : humFiltersOption"
        (exportComponents)="openExportDialog($event)"
        (archiveComponents)="openArchiveDialog()"
        (projectDialogTrigger)="openProjectDialog()"
        (unselectTrigger)="onClearSelectionTrigger()"
        (switchView)="onSwitchView($event)"
      ></app-components-menu>
    </div>

    <div
      class="components-content"
      [ngClass]="{
        'border-top-1': isProjectComponentlist
      }"
    >
      @if (showMap) { @if (loadingMapData) {
      <div class="progress-container">
        <div class="progress-bar" id="progress-bar" [style.width]="loadingProgressPercentage + '%'"></div>
      </div>
      }
      <app-map
        id="component-map"
        [components]="(mapData | async) || []"
        [solution]="solutionSpace"
        [geofences]="selectedGeofences"
        (searchInArea)="onSearchInArea($event)"
      ></app-map>
      } @if (!showMap) {
      <div class="table-wrapper pr-l">
        <mat-card class="card-margin info-card shadow-card pt-xs">
          <mat-card-content>
            <div [hidden]="!loaded" id="component-list-table-wrapper">
              <app-table
                id="component-table"
                #tableComponent
                [bulkEnabled]="true"
                [tableCols]="visibleColumns"
                phoneLayout="rows"
                [showSum]="true"
                [dataSource]="dataSource"
                [selectedPageIndex]="pageNumber"
                [pageSize]="pageSize"
                [totalItems]="totalItemCount"
                sumLabel="SHARED.TABLE.TOTAL"
                [infiniteScrollOnPhone]="true"
                (paginationChanged)="onPaginationChanged($event)"
                (selectionChanged)="onSelectionChanged($event)"
                (sortingChanged)="onSortingChanged($event)"
                [pageSizeOptions]="pageSizeOptions"
              ></app-table>
            </div>
            @if (!loaded) {
            <div class="spinner-wrapper">
              <mat-spinner></mat-spinner>
            </div>
            }
          </mat-card-content>
        </mat-card>
      </div>
      }
    </div>
  </mat-tab-nav-panel>
</div>
